import React from 'react';
import ServicePageTemplate from '../../../components/ServicePageTemplate/ServicePageTemplate';
import { getCategoryCatalog } from '../../../adapters/serviceCatalogAdapter';

const HomePoojaServicesPage = ({ onNavigate }) => {
  const catalog = getCategoryCatalog('homePooja');

  return (
    <ServicePageTemplate
      serviceType="homePooja"
      services={catalog.services}
      filters={catalog.filters}
      pageConfig={catalog.pageConfig}
      onNavigate={onNavigate}
    />
  );
};

export default HomePoojaServicesPage;

